export const publicVersion = "ui.touch.bindings-v1.3-0-gfa7c72e2";